import { render, staticRenderFns } from "./ProxyGuideView.vue?vue&type=template&id=159540bc&scoped=true"
var script = {}
import style0 from "./ProxyGuideView.vue?vue&type=style&index=0&id=159540bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e7c46a58a2b84365ed6c46ff010356d5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159540bc",
  null
  
)

export default component.exports